import { AxiosError } from "axios";
import { SchedulerBlockTypeDTO, ServiceDTO } from "./Scheduler/SchedulerClient";
export class DocumentDTO implements IDocumentDTO {
    id?: number;
    writeRevision?: boolean | null;
    identity?: string;
    name?: string | null;
    caseId?: number;
    parentCaseId?: number;
    caseTypeId?: number;
    date?: Date;
    documentStateId?: number;
    documentTypeId?: number;
    documentCommunicationTypeId?: number;
    documentIssuerId?: number;
    issuerNumber?: string | null;
    issuerDate?: Date;
    documentModeId?: number;
    currentFile?: FileDTO;

    constructor(data?: IDocumentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.identity = _data["identity"] !== undefined ? _data["identity"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.caseId = _data["caseId"] !== undefined ? _data["caseId"] : <any>null;
            this.parentCaseId = _data["parentCaseId"] !== undefined ? _data["parentCaseId"] : <any>null;
            this.caseTypeId = _data["caseTypeId"] !== undefined ? _data["caseTypeId"] : <any>null;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.documentStateId = _data["documentStateId"] !== undefined ? _data["documentStateId"] : <any>null;
            this.documentTypeId = _data["documentTypeId"] !== undefined ? _data["documentTypeId"] : <any>null;
            this.documentCommunicationTypeId = _data["documentCommunicationTypeId"] !== undefined ? _data["documentCommunicationTypeId"] : <any>null;
            this.documentIssuerId = _data["documentIssuerId"] !== undefined ? _data["documentIssuerId"] : <any>null;
            this.issuerNumber = _data["issuerNumber"] !== undefined ? _data["issuerNumber"] : <any>null;
            this.issuerDate = _data["issuerDate"] ? new Date(_data["issuerDate"].toString()) : <any>null;
            this.documentModeId = _data["documentModeId"] !== undefined ? _data["documentModeId"] : <any>null;
            this.currentFile = _data["currentFile"] ? FileDTO.fromJS(_data["currentFile"]) : <any>null;
        }
    }

    static fromJS(data: any): DocumentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["identity"] = this.identity !== undefined ? this.identity : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["caseId"] = this.caseId !== undefined ? this.caseId : <any>null;
        data["parentCaseId"] = this.parentCaseId !== undefined ? this.parentCaseId : <any>null;
        data["caseTypeId"] = this.caseTypeId !== undefined ? this.caseTypeId : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["documentStateId"] = this.documentStateId !== undefined ? this.documentStateId : <any>null;
        data["documentTypeId"] = this.documentTypeId !== undefined ? this.documentTypeId : <any>null;
        data["documentCommunicationTypeId"] = this.documentCommunicationTypeId !== undefined ? this.documentCommunicationTypeId : <any>null;
        data["documentIssuerId"] = this.documentIssuerId !== undefined ? this.documentIssuerId : <any>null;
        data["issuerNumber"] = this.issuerNumber !== undefined ? this.issuerNumber : <any>null;
        data["issuerDate"] = this.issuerDate ? this.issuerDate.toISOString() : <any>null;
        data["documentModeId"] = this.documentModeId !== undefined ? this.documentModeId : <any>null;
        data["currentFile"] = this.currentFile ? this.currentFile.toJSON() : <any>null;
        return data;
    }
}
export class FileDTO implements IFileDTO {
    id?: number;
    writeRevision?: boolean | null;
    identity?: string;
    fileName?: string | null;
    documentUploadTypeId?: number;

    constructor(data?: IFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.identity = _data["identity"] !== undefined ? _data["identity"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.documentUploadTypeId = _data["documentUploadTypeId"] !== undefined ? _data["documentUploadTypeId"] : <any>null;
        }
    }

    static fromJS(data: any): FileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["identity"] = this.identity !== undefined ? this.identity : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["documentUploadTypeId"] = this.documentUploadTypeId !== undefined ? this.documentUploadTypeId : <any>null;
        return data;
    }
}

export interface IFileDTO {
    id?: number;
    writeRevision?: boolean | null;
    identity?: string;
    fileName?: string | null;
    documentUploadTypeId?: number;
}

export interface IDocumentDTO {
    id?: number;
    writeRevision?: boolean | null;
    identity?: string;
    name?: string | null;
    caseId?: number;
    parentCaseId?: number;
    caseTypeId?: number;
    date?: Date;
    documentStateId?: number;
    documentTypeId?: number;
    documentCommunicationTypeId?: number;
    documentIssuerId?: number;
    issuerNumber?: string | null;
    issuerDate?: Date;
    documentModeId?: number;
    currentFile?: FileDTO;
}
export class AddressDTO implements IAddressDTO {
  id?: number | 0;
  districtId?: number;
  townId?: number | null;
  streetId?: number | null;
  streetNumber?: string | null;
  streetBlock?: string | null;
  appartment?: string | null;

  constructor(data?: IAddressDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.districtId = _data["districtId"] !== undefined ? _data["districtId"] : <any>null;
      this.townId = _data["townId"] !== undefined ? _data["townId"] : <any>null;
      this.streetId = _data["streetId"] !== undefined ? _data["streetId"] : <any>null;
      this.streetNumber = _data["streetNumber"] !== undefined ? _data["streetNumber"] : <any>null;
      this.streetBlock = _data["streetBlock"] !== undefined ? _data["streetBlock"] : <any>null;
      this.appartment = _data["appartment"] !== undefined ? _data["appartment"] : <any>null;
    }
  }

  static fromJS(data: any): AddressDTO {
    data = typeof data === 'object' ? data : {};
    let result = new AddressDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["districtId"] = this.districtId !== undefined ? this.districtId : <any>null;
    data["townId"] = this.townId !== undefined ? this.townId : <any>null;
    data["streetId"] = this.streetId !== undefined ? this.streetId : <any>null;
    data["streetNumber"] = this.streetNumber !== undefined ? this.streetNumber : <any>null;
    data["streetBlock"] = this.streetBlock !== undefined ? this.streetBlock : <any>null;
    data["appartment"] = this.appartment !== undefined ? this.appartment : <any>null;
    return data;
  }
}

export interface IAddressDTO {
  id?: number | 0;
  districtId?: number;
  townId?: number | null;
  streetId?: number | null;
  streetNumber?: string | null;
  streetBlock?: string | null;
  appartment?: string | null;
}

export class ClinicDTO implements IClinicDTO {
  id?: number | 0;
  name?: string | null;

  constructor(data?: IClinicDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
    }
  }

  static fromJS(data: any): ClinicDTO {
    data = typeof data === 'object' ? data : {};
    let result = new ClinicDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    return data;
  }
}

export interface IClinicDTO {
  id?: number | 0;
  name?: string | null;
}

export class DoctorDTO implements IDoctorDTO {
  id?: number;
  person?: PersonDTO;
  medicalProfile?: MedicalProfileDTO;
  employee?: EmployeeDTO;

  constructor(data?: IDoctorDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.person = _data["person"] ? PersonDTO.fromJS(_data["person"]) : <any>null;
      this.medicalProfile = _data["medicalProfile"] ? MedicalProfileDTO.fromJS(_data["medicalProfile"]) : <any>null;
      this.employee = _data["employee"] ? EmployeeDTO.fromJS(_data["employee"]) : <any>null;
    }
  }

  static fromJS(data: any): DoctorDTO {
    data = typeof data === 'object' ? data : {};
    let result = new DoctorDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["person"] = this.person ? this.person.toJSON() : <any>null;
    data["medicalProfile"] = this.medicalProfile ? this.medicalProfile.toJSON() : <any>null;
    data["employee"] = this.employee ? this.employee.toJSON() : <any>null;
    return data;
  }
}

export interface IDoctorDTO {
  id?: number;
  person?: PersonDTO;
  medicalProfile?: MedicalProfileDTO;
  employee?: EmployeeDTO;
}

export class DoctorFiltersDTO implements IDoctorFiltersDTO {
  medicalProfile?: MedicalProfileDTO;
  clinics?: ClinicDTO[] | null;

  constructor(data?: IDoctorFiltersDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.medicalProfile = _data["medicalProfile"] ? MedicalProfileDTO.fromJS(_data["medicalProfile"]) : <any>null;
      if (Array.isArray(_data["clinics"])) {
        this.clinics = [] as any;
        for (let item of _data["clinics"])
          this.clinics!.push(ClinicDTO.fromJS(item));
      }
      else {
        this.clinics = <any>null;
      }
    }
  }

  static fromJS(data: any): DoctorFiltersDTO {
    data = typeof data === 'object' ? data : {};
    let result = new DoctorFiltersDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["medicalProfile"] = this.medicalProfile ? this.medicalProfile.toJSON() : <any>null;
    if (Array.isArray(this.clinics)) {
      data["clinics"] = [];
      for (let item of this.clinics)
        data["clinics"].push(item.toJSON());
    }
    return data;
  }
}

export interface IDoctorFiltersDTO {
  medicalProfile?: MedicalProfileDTO;
  clinics?: ClinicDTO[] | null;
}

export class EmployeeDTO implements IEmployeeDTO {
  id?: number;
  person?: PersonDTO | undefined;
  clinics?: ClinicDTO[] | undefined;

  constructor(data?: IEmployeeDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.person = _data["person"] ? PersonDTO.fromJS(_data["person"]) : <any>undefined;
          if (Array.isArray(_data["clinics"])) {
              this.clinics = [] as any;
              for (let item of _data["clinics"])
                  this.clinics!.push(ClinicDTO.fromJS(item));
          }
      }
  }

  static fromJS(data: any): EmployeeDTO {
      data = typeof data === 'object' ? data : {};
      let result = new EmployeeDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["person"] = this.person ? this.person.toJSON() : <any>undefined;
      if (Array.isArray(this.clinics)) {
          data["clinics"] = [];
          for (let item of this.clinics)
              data["clinics"].push(item.toJSON());
      }
      return data;
  }
}

export interface IEmployeeDTO {
  id?: number;
  person?: PersonDTO | undefined;
  clinics?: ClinicDTO[] | undefined;
}


export class FormAccessDTO implements IFormAccessDTO {
  hasSaveAccess?: boolean;
  hasDeleteAccess?: boolean;

  constructor(data?: IFormAccessDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hasSaveAccess = _data["hasSaveAccess"] !== undefined ? _data["hasSaveAccess"] : <any>null;
      this.hasDeleteAccess = _data["hasDeleteAccess"] !== undefined ? _data["hasDeleteAccess"] : <any>null;
    }
  }

  static fromJS(data: any): FormAccessDTO {
    data = typeof data === 'object' ? data : {};
    let result = new FormAccessDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hasSaveAccess"] = this.hasSaveAccess !== undefined ? this.hasSaveAccess : <any>null;
    data["hasDeleteAccess"] = this.hasDeleteAccess !== undefined ? this.hasDeleteAccess : <any>null;
    return data;
  }
}

export interface IFormAccessDTO {
  hasSaveAccess?: boolean;
  hasDeleteAccess?: boolean;
}

export class MedicalProfileDTO implements IMedicalProfileDTO {
  id?: number;
  name?: string | null;

  constructor(data?: IMedicalProfileDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
    }
  }

  static fromJS(data: any): MedicalProfileDTO {
    data = typeof data === 'object' ? data : {};
    let result = new MedicalProfileDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    return data;
  }
}

export interface IMedicalProfileDTO {
  id?: number;
  name?: string | null;
}

export class PatientCategoryDTO implements IPatientCategoryDTO {
  id?: number;
  name?: string | null;

  constructor(data?: IPatientCategoryDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
    }
  }

  static fromJS(data: any): PatientCategoryDTO {
    data = typeof data === 'object' ? data : {};
    let result = new PatientCategoryDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    return data;
  }
}

export interface IPatientCategoryDTO {
  id?: number;
  name?: string | null;
}

export class PatientDTO implements IPatientDTO {
  id?: number | 0;
  personId?: number | 0;
  person?: PersonDTO;
  email?: string | null;
  passSeries?: string | null;
  passNumber?: string | null;
  dependent?: string | null;
  phone?: string | null;
  maritalStatusId?: number | null;
  citizenshipId?: number | null;
  bloodGroupId?: number | null;
  bloodGroup?: BloodGroupDTO;
  rhId?: number | null;
  rh?: RHDTO;
  patientCategoryId?: number;
  patientCategory?: PatientCategoryDTO;
  addressId?: number | 0;
  address?: AddressDTO;
  differentAddresses?: boolean | null;
  residenceAddressId?: number | 0;
  residenceAddress?: AddressDTO;
  profession?: string | null;
  familyMedic?: DoctorDTO;
  job?: string | null;
  studies?: string | null;

  constructor(data?: IPatientDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.personId = _data["personId"] !== undefined ? _data["personId"] : <any>null;
      this.person = _data["person"] ? PersonDTO.fromJS(_data["person"]) : <any>null;
      this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
      this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
      this.passNumber = _data["passNumber"] !== undefined ? _data["passNumber"] : <any>null;
      this.passSeries = _data["passSeries"] !== undefined ? _data["passSeries"] : <any>null;
      this.dependent = _data["dependent"] !== undefined ? _data["dependent"] : <any>null;
      this.maritalStatusId = _data["maritalStatusId"] !== undefined ? _data["maritalStatusId"] : <any>null;
      this.citizenshipId = _data["citizenshipId"] !== undefined ? _data["citizenshipId"] : <any>null;
      this.bloodGroupId = _data["bloodGroupId"] !== undefined ? _data["bloodGroupId"] : <any>null;
      this.bloodGroup = _data["bloodGroup"] ? BloodGroupDTO.fromJS(_data["bloodGroup"]) : <any>null;
      this.rhId = _data["rhId"] !== undefined ? _data["rhId"] : <any>null;
      this.rh = _data["rh"] ? RHDTO.fromJS(_data["rh"]) : <any>null;
      this.patientCategoryId = _data["patientCategoryId"] !== undefined ? _data["patientCategoryId"] : <any>null;
      this.patientCategory = _data["patientCategory"] ? PatientCategoryDTO.fromJS(_data["patientCategory"]) : <any>null;
      this.addressId = _data["addressId"] !== undefined ? _data["addressId"] : <any>null;
      this.address = _data["address"] ? AddressDTO.fromJS(_data["address"]) : <any>null;
      this.differentAddresses = _data["differentAddresses"] !== undefined ? _data["differentAddresses"] : <any>null;
      this.residenceAddressId = _data["residenceAddressId"] !== undefined ? _data["residenceAddressId"] : <any>null;
      this.residenceAddress = _data["residenceAddress"] ? AddressDTO.fromJS(_data["residenceAddress"]) : <any>null;
      this.familyMedic = _data["familyMedic"] ? DoctorDTO.fromJS(_data["familyMedic"]) : <any>null;
      this.profession = _data["profession"] !== undefined ? _data["profession"] : <any>null;
      this.job = _data["job"] !== undefined ? _data["job"] : <any>null;
      this.studies = _data["studies"] !== undefined ? _data["studies"] : <any>null;
    }
  }

  static fromJS(data: any): PatientDTO {
    data = typeof data === 'object' ? data : {};
    let result = new PatientDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["personId"] = this.personId !== undefined ? this.personId : <any>null;
    data["person"] = this.person ? this.person.toJSON() : <any>null;
    data["email"] = this.email !== undefined ? this.email : <any>null;
    data["passSeries"] = this.passSeries !== undefined ? this.passSeries : <any>null;
    data["passNumber"] = this.passNumber !== undefined ? this.passNumber : <any>null;
    data["dependent"] = this.dependent !== undefined ? this.dependent : <any>null;
    data["phone"] = this.phone !== undefined ? this.phone : <any>null;
    data["maritalStatusId"] = this.maritalStatusId !== undefined ? this.maritalStatusId : <any>null;
    data["citizenshipId"] = this.citizenshipId !== undefined ? this.citizenshipId : <any>null;
    data["bloodGroupId"] = this.bloodGroupId !== undefined ? this.bloodGroupId : <any>null;
    data["bloodGroup"] = this.bloodGroup ? this.bloodGroup.toJSON() : <any>null;
    data["rhId"] = this.rhId !== undefined ? this.rhId : <any>null;
    data["rh"] = this.rh ? this.rh.toJSON() : <any>null;
    data["patientCategoryId"] = this.patientCategoryId !== undefined ? this.patientCategoryId : <any>null;
    data["patientCategory"] = this.patientCategory ? this.patientCategory.toJSON() : <any>null;
    data["addressId"] = this.addressId !== undefined ? this.addressId : <any>null;
    data["address"] = this.address ? this.address.toJSON() : <any>null;
    data["differentAddresses"] = this.differentAddresses !== undefined ? this.differentAddresses : <any>null;
    data["residenceAddressId"] = this.residenceAddressId !== undefined ? this.residenceAddressId : <any>null;
    data["residenceAddress"] = this.residenceAddress ? this.residenceAddress.toJSON() : <any>null;
    data["profession"] = this.profession !== undefined ? this.profession : <any>null;
    data["familyMedic"] = this.familyMedic ? this.familyMedic.toJSON() : <any>null;
    data["job"] = this.job !== undefined ? this.job : <any>null;
    data["studies"] = this.studies !== undefined ? this.studies : <any>null;
    return data;
  }
}

export interface IPatientDTO {
  id?: number | 0;
  personId?: number | 0;
  person?: PersonDTO;
  email?: string | null;
  phone?: string | null;
  passSeries?: string | null;
  passNumber?: string | null;
  dependent?: string | null;
  maritalStatusId?: number | null;
  citizenshipId?: number | null;
  bloodGroupId?: number | null;
  bloodGroup?: BloodGroupDTO;
  rhId?: number | null;
  rh?: RHDTO;
  patientCategoryId?: number;
  patientCategory?: PatientCategoryDTO;
  addressId?: number | null;
  address?: AddressDTO;
  differentAddresses?: boolean | null;
  residenceAddressId?: number | null;
  residenceAddress?: AddressDTO;
  familyMedic?: DoctorDTO;
  profession?: string | null;
  job?: string | null;
  studies?: string | null;
}

export class PatientDTOFormItemResult implements IPatientDTOFormItemResult {
  entityDTO?: PatientDTO;
  formAccess?: FormAccessDTO;

  constructor(data?: IPatientDTOFormItemResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.entityDTO = _data["entityDTO"] ? PatientDTO.fromJS(_data["entityDTO"]) : <any>null;
      this.formAccess = _data["formAccess"] ? FormAccessDTO.fromJS(_data["formAccess"]) : <any>null;
    }
  }

  static fromJS(data: any): PatientDTOFormItemResult {
    data = typeof data === 'object' ? data : {};
    let result = new PatientDTOFormItemResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["entityDTO"] = this.entityDTO ? this.entityDTO.toJSON() : <any>null;
    data["formAccess"] = this.formAccess ? this.formAccess.toJSON() : <any>null;
    return data;
  }
}

export class PatientNavigationDTO implements IPatientNavigationDTO {
  presentationId?: number;
  patientId?: number;
  appointmentId?: number;
  checkUpId?: number;
  surveyId?: number;
  checkInId?: number;

  constructor(data?: IPatientNavigationDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.presentationId = _data["presentationId"] !== undefined ? _data["presentationId"] : <any>null;
          this.patientId = _data["patientId"] !== undefined ? _data["patientId"] : <any>null;
          this.appointmentId = _data["appointmentId"] !== undefined ? _data["appointmentId"] : <any>null;
          this.checkUpId = _data["checkUpId"] !== undefined ? _data["checkUpId"] : <any>null;
          this.surveyId = _data["surveyId"] !== undefined ? _data["surveyId"] : <any>null;
          this.checkInId = _data["checkInId"] !== undefined ? _data["checkInId"] : <any>null;
      }
  }

  static fromJS(data: any): PatientNavigationDTO {
      data = typeof data === 'object' ? data : {};
      let result = new PatientNavigationDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["presentationId"] = this.presentationId !== undefined ? this.presentationId : <any>null;
      data["patientId"] = this.patientId !== undefined ? this.patientId : <any>null;
      data["appointmentId"] = this.appointmentId !== undefined ? this.appointmentId : <any>null;
      data["checkUpId"] = this.checkUpId !== undefined ? this.checkUpId : <any>null;
      data["surveyId"] = this.surveyId !== undefined ? this.surveyId : <any>null;
      data["checkInId"] = this.checkInId !== undefined ? this.checkInId : <any>null;
      return data;
  }
}

export interface IPatientNavigationDTO {
  presentationId?: number;
  patientId?: number;
  appointmentId?: number;
  checkUpId?: number;
  surveyId?: number;
  checkInId?: number;
}
export class ConsultationValueDTO implements IConsultationValueDTO {
  id?: number;
  consultationId?: number;
  consultation?: ConsultationDTO;
  key?: string | null;
  value?: string | null;

  constructor(data?: IConsultationValueDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.consultationId = _data["consultationId"] !== undefined ? _data["consultationId"] : <any>null;
          this.consultation = _data["consultation"] ? ConsultationDTO.fromJS(_data["consultation"]) : <any>null;
          this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
          this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
      }
  }

  static fromJS(data: any): ConsultationValueDTO {
      data = typeof data === 'object' ? data : {};
      let result = new ConsultationValueDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["consultationId"] = this.consultationId !== undefined ? this.consultationId : <any>null;
      data["consultation"] = this.consultation ? this.consultation.toJSON() : <any>null;
      data["key"] = this.key !== undefined ? this.key : <any>null;
      data["value"] = this.value !== undefined ? this.value : <any>null;
      return data;
  }
}

export interface IConsultationValueDTO {
  id?: number;
  consultationId?: number;
  consultation?: ConsultationDTO;
  key?: string | null;
  value?: string | null;
}

export interface IPatientDTOFormItemResult {
  entityDTO?: PatientDTO;
  formAccess?: FormAccessDTO;
}

export class PersonDTO implements IPersonDTO {
  id?: number | 0;
  firstName?: string | null;
  lastName?: string | null;
  patronymic?: string | null;
  birthDate?: Date | null;
  sexId?: number | null;
  identityNumber?: string | null;

  constructor(data?: IPersonDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
      this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
      this.patronymic = _data["patronymic"] !== undefined ? _data["patronymic"] : <any>null;
      this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
      this.sexId = _data["sexId"] !== undefined ? _data["sexId"] : <any>null;
      this.identityNumber = _data["identityNumber"] !== undefined ? _data["identityNumber"] : <any>null;
    }
  }

  static fromJS(data: any): PersonDTO {
    data = typeof data === 'object' ? data : {};
    let result = new PersonDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
    data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
    data["patronymic"] = this.patronymic !== undefined ? this.patronymic : <any>null;
    data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
    data["sexId"] = this.sexId !== undefined ? this.sexId : <any>null;
    data["identityNumber"] = this.identityNumber !== undefined ? this.identityNumber : <any>null;
    return data;
  }
}

export interface IPersonDTO {
  id?: number | 0;
  firstName?: string | null;
  lastName?: string | null;
  patronymic?: string | null;
  birthDate?: Date | null;
  sexId?: number | null;
  identityNumber?: string | null;
}

export class PersonDTOFormItemResult implements IPersonDTOFormItemResult {
  entityDTO?: PersonDTO;
  formAccess?: FormAccessDTO;

  constructor(data?: IPersonDTOFormItemResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.entityDTO = _data["entityDTO"] ? PersonDTO.fromJS(_data["entityDTO"]) : <any>null;
      this.formAccess = _data["formAccess"] ? FormAccessDTO.fromJS(_data["formAccess"]) : <any>null;
    }
  }

  static fromJS(data: any): PersonDTOFormItemResult {
    data = typeof data === 'object' ? data : {};
    let result = new PersonDTOFormItemResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["entityDTO"] = this.entityDTO ? this.entityDTO.toJSON() : <any>null;
    data["formAccess"] = this.formAccess ? this.formAccess.toJSON() : <any>null;
    return data;
  }
}

export interface IPersonDTOFormItemResult {
  entityDTO?: PersonDTO;
  formAccess?: FormAccessDTO;
}



export class PresentationDTO implements IPresentationDTO {
  id?: number;
  patientId?: number| null;
  patient?: PatientDTO;
  presentationTypeId?: number| null;
  presentationStatusId?: number | null;
  nurseTypeId?: number | null;
  decision?: string | null;
  clinicId?: number| null;
  motiveId?: number| null;
  doctorId?: number| null;
  doctor?: DoctorDTO;
  recordNumber?: string | null;
  appointmentId?: number | null;
  insuranceCategoryId?: number | null;
  insuranceTypeId?: number | null;
  insurerId?: number | null;
  insuranceStatusId?: number| null;
  insuranceStatus?: InsuranceStatusDTO| null;
  insuranceNumber?: string | null;
  dateCreated?: Date| null;
  datePresentation?: Date | null;
  medicalProfileId?: number | null;
  medicalProfile?: MedicalProfileDTO;

  constructor(data?: IPresentationDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.patientId = _data["patientId"] !== undefined ? _data["patientId"] : <any>null;
          this.patient = _data["patient"] ? PatientDTO.fromJS(_data["patient"]) : <any>null;
          this.presentationTypeId = _data["presentationTypeId"] !== undefined ? _data["presentationTypeId"] : <any>null;
          this.presentationStatusId = _data["presentationStatusId"] !== undefined ? _data["presentationStatusId"] : <any>null;
          this.nurseTypeId = _data["nurseTypeId"] !== undefined ? _data["nurseTypeId"] : <any>null;
          this.decision = _data["decision"] !== undefined ? _data["decision"] : <any>null;
          this.clinicId = _data["clinicId"] !== undefined ? _data["clinicId"] : <any>null;
          this.motiveId = _data["motiveId"] !== undefined ? _data["motiveId"] : <any>null;
          this.doctorId = _data["doctorId"] !== undefined ? _data["doctorId"] : <any>null;
          this.doctor = _data["doctor"] ? DoctorDTO.fromJS(_data["doctor"]) : <any>null;
          this.recordNumber = _data["recordNumber"] !== undefined ? _data["recordNumber"] : <any>null;
          this.appointmentId = _data["appointmentId"] !== undefined ? _data["appointmentId"] : <any>null;
          this.insuranceCategoryId = _data["insuranceCategoryId"] !== undefined ? _data["insuranceCategoryId"] : <any>null;
          this.insuranceTypeId = _data["insuranceTypeId"] !== undefined ? _data["insuranceTypeId"] : <any>null;
          this.insurerId = _data["insurerId"] !== undefined ? _data["insurerId"] : <any>null;
          this.insuranceStatusId = _data["insuranceStatusId"] !== undefined ? _data["insuranceStatusId"] : <any>null;
          this.insuranceStatus = _data["insuranceStatus"] ? InsuranceStatusDTO.fromJS(_data["insuranceStatus"]) : <any>null;
          this.insuranceNumber = _data["insuranceNumber"] !== undefined ? _data["insuranceNumber"] : <any>null;
          this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>null;
          this.datePresentation = _data["datePresentation"] ? new Date(_data["datePresentation"].toString()) : <any>null;
          this.medicalProfileId = _data["medicalProfileId"] !== undefined ? _data["medicalProfileId"] : <any>null;
          this.medicalProfile = _data["medicalProfile"] ? MedicalProfileDTO.fromJS(_data["medicalProfile"]) : <any>null;
      }
  }

  static fromJS(data: any): PresentationDTO {
      data = typeof data === 'object' ? data : {};
      let result = new PresentationDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["patientId"] = this.patientId !== undefined ? this.patientId : <any>null;
      data["patient"] = this.patient ? this.patient.toJSON() : <any>null;
      data["presentationTypeId"] = this.presentationTypeId !== undefined ? this.presentationTypeId : <any>null;
      data["presentationStatusId"] = this.presentationStatusId !== undefined ? this.presentationStatusId : <any>null;
      data["nurseTypeId"] = this.nurseTypeId !== undefined ? this.nurseTypeId : <any>null;
      data["decision"] = this.decision !== undefined ? this.decision : <any>null;
      data["clinicId"] = this.clinicId !== undefined ? this.clinicId : <any>null;
      data["motiveId"] = this.motiveId !== undefined ? this.motiveId : <any>null;
      data["doctorId"] = this.doctorId !== undefined ? this.doctorId : <any>null;
      data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>null;
      data["recordNumber"] = this.recordNumber !== undefined ? this.recordNumber : <any>null;
      data["appointmentId"] = this.appointmentId !== undefined ? this.appointmentId : <any>null;
      data["insuranceCategoryId"] = this.insuranceCategoryId !== undefined ? this.insuranceCategoryId : <any>null;
      data["insuranceTypeId"] = this.insuranceTypeId !== undefined ? this.insuranceTypeId : <any>null;
      data["insurerId"] = this.insurerId !== undefined ? this.insurerId : <any>null;
      data["insuranceStatusId"] = this.insuranceStatusId !== undefined ? this.insuranceStatusId : <any>null;
      data["insuranceStatus"] = this.insuranceStatus ? this.insuranceStatus.toJSON() : <any>null;
      data["insuranceNumber"] = this.insuranceNumber !== undefined ? this.insuranceNumber : <any>null;
      data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>null;
      data["datePresentation"] = this.datePresentation ? this.datePresentation.toISOString() : <any>null;
      data["medicalProfileId"] = this.medicalProfileId !== undefined ? this.medicalProfileId : <any>null;
      data["medicalProfile"] = this.medicalProfile ? this.medicalProfile.toJSON() : <any>null;
      return data;
  }
}

export interface IPresentationDTO {
  id?: number| null;
  patientId?: number| null;
  patient?: PatientDTO;
  presentationTypeId?: number| null;
  presentationStatusId?: number | null;
  nurseTypeId?: number | null;
  decision?: string | null;
  clinicId?: number| null;
  motiveId?: number| null;
  doctorId?: number| null;
  doctor?: DoctorDTO| null;
  recordNumber?: string | null;
  appointmentId?: number | null;
  insuranceCategoryId?: number | null;
  insuranceTypeId?: number | null;
  insurerId?: number | null;
  insuranceStatusId?: number| null;
  insuranceStatus?: InsuranceStatusDTO| null;
  insuranceNumber?: string | null;
  dateCreated?: Date| null;
  datePresentation?: Date | null;
  medicalProfileId?: number | null;
  medicalProfile?: MedicalProfileDTO;
}



export class PresentationDTOFormItemResult implements IPresentationDTOFormItemResult {
  entityDTO?: PresentationDTO;
  formAccess?: FormAccessDTO;

  constructor(data?: IPresentationDTOFormItemResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.entityDTO = _data["entityDTO"] ? PresentationDTO.fromJS(_data["entityDTO"]) : <any>null;
      this.formAccess = _data["formAccess"] ? FormAccessDTO.fromJS(_data["formAccess"]) : <any>null;
    }
  }

  static fromJS(data: any): PresentationDTOFormItemResult {
    data = typeof data === 'object' ? data : {};
    let result = new PresentationDTOFormItemResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["entityDTO"] = this.entityDTO ? this.entityDTO.toJSON() : <any>null;
    data["formAccess"] = this.formAccess ? this.formAccess.toJSON() : <any>null;
    return data;
  }
}

export interface IPresentationDTOFormItemResult {
  entityDTO?: PresentationDTO;
  formAccess?: FormAccessDTO;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
  if (result !== null && result !== undefined)
    throw result;
  else
    throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}

export class DocumentTypeDTO implements IDocumentTypeDTO {
  id?: number;
  name?: string | null;
  tag?: string | null;

  constructor(data?: IDocumentTypeDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
    }
  }

  static fromJS(data: any): DocumentTypeDTO {
    data = typeof data === 'object' ? data : {};
    let result = new DocumentTypeDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["tag"] = this.tag !== undefined ? this.tag : <any>null;
    return data;
  }
}

export interface IDocumentTypeDTO {
  id?: number;
  name?: string | null;
  tag?: string | null;
}

export class ConsultationDTO implements IConsultationDTO {
  id?: number;
  writeRevision?: boolean | null;
  consultationType?: ConsultationTypeDTO;
  presentation?: PresentationDTO;
  requesterCheckUp?: CheckUpDTO;
  checkUp?: CheckUpDTO;
  consultationMotive?: BaseNomDTO;
  consultationPrimaryType?: BaseNomDTO;
  consultationPlace?: BaseNomDTO;
  consultationStatus?: BaseNomDTO;
  medicalOperationGroup?: BaseNomDTO;
  doctor?: DoctorDTO;
  accuses?: string | null;
  html?: string | null;
  appointmentId?: number | null;
  consultationDate?: Date | null;
  dueDate?: Date | null;
  scheduledDate?: Date | null;

  constructor(data?: IConsultationDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
          this.consultationType = _data["consultationType"] ? ConsultationTypeDTO.fromJS(_data["consultationType"]) : <any>null;
          this.presentation = _data["presentation"] ? PresentationDTO.fromJS(_data["presentation"]) : <any>null;
          this.requesterCheckUp = _data["requesterCheckUp"] ? CheckUpDTO.fromJS(_data["requesterCheckUp"]) : <any>null;
          this.checkUp = _data["checkUp"] ? CheckUpDTO.fromJS(_data["checkUp"]) : <any>null;
          this.consultationMotive = _data["consultationMotive"] ? BaseNomDTO.fromJS(_data["consultationMotive"]) : <any>null;
          this.consultationPrimaryType = _data["consultationPrimaryType"] ? BaseNomDTO.fromJS(_data["consultationPrimaryType"]) : <any>null;
          this.consultationPlace = _data["consultationPlace"] ? BaseNomDTO.fromJS(_data["consultationPlace"]) : <any>null;
          this.consultationStatus = _data["consultationStatus"] ? BaseNomDTO.fromJS(_data["consultationStatus"]) : <any>null;
          this.medicalOperationGroup = _data["medicalOperationGroup"] ? BaseNomDTO.fromJS(_data["medicalOperationGroup"]) : <any>null;
          this.doctor = _data["doctor"] ? DoctorDTO.fromJS(_data["doctor"]) : <any>null;
          this.accuses = _data["accuses"] !== undefined ? _data["accuses"] : <any>null;
          this.html = _data["html"] !== undefined ? _data["html"] : <any>null;
          this.appointmentId = _data["appointmentId"] !== undefined ? _data["appointmentId"] : <any>null;
          this.consultationDate = _data["consultationDate"] ? new Date(_data["consultationDate"].toString()) : <any>null;
          this.scheduledDate = _data["scheduledDate"] ? new Date(_data["scheduledDate"].toString()) : <any>null;
          this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>null;
      }
  }

  static fromJS(data: any): ConsultationDTO {
      data = typeof data === 'object' ? data : {};
      let result = new ConsultationDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
      data["consultationType"] = this.consultationType ? this.consultationType.toJSON() : <any>null;
      data["presentation"] = this.presentation ? this.presentation.toJSON() : <any>null;
      data["requesterCheckUp"] = this.requesterCheckUp ? this.requesterCheckUp.toJSON() : <any>null;
      data["checkUp"] = this.checkUp ? this.checkUp.toJSON() : <any>null;
      data["consultationMotive"] = this.consultationMotive ? this.consultationMotive.toJSON() : <any>null;
      data["consultationPrimaryType"] = this.consultationPrimaryType ? this.consultationPrimaryType.toJSON() : <any>null;
      data["consultationPlace"] = this.consultationPlace ? this.consultationPlace.toJSON() : <any>null;
      data["consultationStatus"] = this.consultationStatus ? this.consultationStatus.toJSON() : <any>null;
      data["medicalOperationGroup"] = this.medicalOperationGroup ? this.medicalOperationGroup.toJSON() : <any>null;
      data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>null;
      data["accuses"] = this.accuses !== undefined ? this.accuses : <any>null;
      data["html"] = this.html !== undefined ? this.html : <any>null;
      data["appointmentId"] = this.appointmentId !== undefined ? this.appointmentId : <any>null;
      data["consultationDate"] = this.consultationDate ? this.consultationDate.toISOString() : <any>null;
      data["scheduledDate"] = this.scheduledDate ? this.scheduledDate.toISOString() : <any>null;
      data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>null;
      return data;
  }
}

export interface IConsultationDTO {
  id?: number;
  writeRevision?: boolean | null;
  consultationType?: ConsultationTypeDTO;
  presentation?: PresentationDTO;
  requesterCheckUp?: CheckUpDTO;
  checkUp?: CheckUpDTO;
  consultationMotive?: BaseNomDTO;
  consultationPrimaryType?: BaseNomDTO;
  consultationPlace?: BaseNomDTO;
  consultationStatus?: BaseNomDTO;
  medicalOperationGroup?: BaseNomDTO;
  html?: string | null;
  doctor?: DoctorDTO;
  accuses?: string | null;
  appointmentId?: number | null;
  consultationDate?: Date | null;
  dueDate?: Date | null;
  scheduledDate?: Date | null;
}

export class ConsultationStatusDTO implements IConsultationStatusDTO {
  id?: number;
  name?: string | undefined;

  constructor(data?: IConsultationStatusDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
      }
  }

  static fromJS(data: any): ConsultationStatusDTO {
      data = typeof data === 'object' ? data : {};
      let result = new ConsultationStatusDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      return data;
  }
}

export interface IConsultationStatusDTO {
  id?: number;
  name?: string | undefined;
}


export class ConsultationDTOFormItemResult implements IConsultationDTOFormItemResult {
  entityDTO?: ConsultationDTO;
  formAccess?: FormAccessDTO;

  constructor(data?: IConsultationDTOFormItemResult) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.entityDTO = _data["entityDTO"] ? ConsultationDTO.fromJS(_data["entityDTO"]) : <any>null;
          this.formAccess = _data["formAccess"] ? FormAccessDTO.fromJS(_data["formAccess"]) : <any>null;
      }
  }

  static fromJS(data: any): ConsultationDTOFormItemResult {
      data = typeof data === 'object' ? data : {};
      let result = new ConsultationDTOFormItemResult();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["entityDTO"] = this.entityDTO ? this.entityDTO.toJSON() : <any>null;
      data["formAccess"] = this.formAccess ? this.formAccess.toJSON() : <any>null;
      return data;
  }
}

export class ConsultationPrimaryTypeDTO implements IConsultationPrimaryTypeDTO {
  id?: number;
  name?: string | null;

  constructor(data?: IConsultationPrimaryTypeDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): ConsultationPrimaryTypeDTO {
      data = typeof data === 'object' ? data : {};
      let result = new ConsultationPrimaryTypeDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface IConsultationPrimaryTypeDTO {
  id?: number;
  name?: string | null;
}


export interface IConsultationDTOFormItemResult {
  entityDTO?: ConsultationDTO;
  formAccess?: FormAccessDTO;
}

export class ConsultationMotiveDTO implements IConsultationMotiveDTO {
  id?: number;
  name?: string | null;

  constructor(data?: IConsultationMotiveDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): ConsultationMotiveDTO {
      data = typeof data === 'object' ? data : {};
      let result = new ConsultationMotiveDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface IConsultationMotiveDTO {
  id?: number;
  name?: string | null;
}

export class ConsultationPlaceDTO implements IConsultationPlaceDTO {
  id?: number;
  name?: string | null;

  constructor(data?: IConsultationPlaceDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): ConsultationPlaceDTO {
      data = typeof data === 'object' ? data : {};
      let result = new ConsultationPlaceDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface IConsultationPlaceDTO {
  id?: number;
  name?: string | null;
}

export class ConsultationTypeDTO implements IConsultationTypeDTO {
  id?: number;
  name?: string | null;
  tag?: string | null;
  medicalProfile?: BaseNomDTO;
  service?: ServiceDTO;

  constructor(data?: IConsultationTypeDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
          this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
          this.medicalProfile = _data["medicalProfile"] ? BaseNomDTO.fromJS(_data["medicalProfile"]) : <any>null;
          this.service = _data["service"] ? ServiceDTO.fromJS(_data["service"]) : <any>null;
      }
  }

  static fromJS(data: any): ConsultationTypeDTO {
      data = typeof data === 'object' ? data : {};
      let result = new ConsultationTypeDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      data["tag"] = this.tag !== undefined ? this.tag : <any>null;
      data["medicalProfile"] = this.medicalProfile ? this.medicalProfile.toJSON() : <any>null;
      data["service"] = this.service ? this.service.toJSON() : <any>null;
      return data;
  }
}

export interface IConsultationTypeDTO {
  id?: number;
  name?: string | null;
  tag?: string | null;
  medicalProfile?: BaseNomDTO;
  service?: ServiceDTO;
}
export class PrecutationDTO implements IPrecutationDTO {
  id?: number;
  name?: string | undefined;

  constructor(data?: IPrecutationDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
      }
  }

  static fromJS(data: any): PrecutationDTO {
      data = typeof data === 'object' ? data : {};
      let result = new PrecutationDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      return data;
  }
}

export interface IPrecutationDTO {
  id?: number;
  name?: string | undefined;
}

export class DietDTO implements IDietDTO {
  id?: number;
  name?: string | undefined;

  constructor(data?: IDietDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
      }
  }

  static fromJS(data: any): DietDTO {
      data = typeof data === 'object' ? data : {};
      let result = new DietDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      return data;
  }
}

export interface IDietDTO {
  id?: number;
  name?: string | undefined;
}
export class TreatmentDTO implements ITreatmentDTO {
  id?: number;
  name?: string | undefined;

  constructor(data?: ITreatmentDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
      }
  }

  static fromJS(data: any): TreatmentDTO {
      data = typeof data === 'object' ? data : {};
      let result = new TreatmentDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      return data;
  }
}

export interface ITreatmentDTO {
  id?: number;
  name?: string | undefined;
}

export class TreatmentRegimeDTO implements ITreatmentRegimeDTO {
  id?: number;
  name?: string | undefined;

  constructor(data?: ITreatmentRegimeDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
      }
  }

  static fromJS(data: any): TreatmentRegimeDTO {
      data = typeof data === 'object' ? data : {};
      let result = new TreatmentRegimeDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      return data;
  }
}

export interface ITreatmentRegimeDTO {
  id?: number;
  name?: string | undefined;
}



export class CheckUpDTO implements ICheckUpDTO {
  id?: number;
  presentation?: PresentationDTO;
  checkUpStatus?: CheckUpStatusDTO;
  medicalProfile?: MedicalProfileDTO;
  freeFormPrez?: string | undefined;
  diagnosisPrez?: DiagnosisDTO;
  freeFormClinic?: string | undefined;
  diagnosisClinic?: DiagnosisDTO;
  diet?: DietDTO;
  precutations?: string | undefined;
  protocol?: ProtocolDTO;
  treatment?: TreatmentDTO;
  treatmentRegime?: TreatmentRegimeDTO;
  checkUpDate?: Date | undefined;
  nextDate?: Date | undefined;
  medicalAnalysisBatches?: string | undefined;
  investigationTypes?: string | undefined;
  dateUpdate?: Date | null;


  constructor(data?: ICheckUpDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.presentation = _data["presentation"] ? PresentationDTO.fromJS(_data["presentation"]) : <any>undefined;
          this.checkUpStatus = _data["checkUpStatus"] ? CheckUpStatusDTO.fromJS(_data["checkUpStatus"]) : <any>undefined;
          this.medicalProfile = _data["medicalProfile"] ? MedicalProfileDTO.fromJS(_data["medicalProfile"]) : <any>undefined;
          this.freeFormPrez = _data["freeFormPrez"];
          this.diagnosisPrez = _data["diagnosisPrez"] ? DiagnosisDTO.fromJS(_data["diagnosisPrez"]) : <any>undefined;
          this.freeFormClinic = _data["freeFormClinic"];
          this.diagnosisClinic = _data["diagnosisClinic"] ? DiagnosisDTO.fromJS(_data["diagnosisClinic"]) : <any>undefined;
          this.diet = _data["diet"] ? DietDTO.fromJS(_data["diet"]) : <any>undefined;
          this.precutations = _data["precutations"];
          this.protocol = _data["protocol"] ? ProtocolDTO.fromJS(_data["protocol"]) : <any>undefined;
          this.treatment = _data["treatment"] ? TreatmentDTO.fromJS(_data["treatment"]) : <any>undefined;
          this.treatmentRegime = _data["treatmentRegime"] ? TreatmentRegimeDTO.fromJS(_data["treatmentRegime"]) : <any>undefined;
          this.checkUpDate = _data["checkUpDate"] ? new Date(_data["checkUpDate"].toString()) : <any>undefined;
          this.nextDate = _data["nextDate"] ? new Date(_data["nextDate"].toString()) : <any>undefined;
          this.medicalAnalysisBatches = _data["medicalAnalysisBatches"];
          this.investigationTypes = _data["investigationTypes"];
          this.dateUpdate = _data["dateUpdate"] ? new Date(_data["dateUpdate"].toString()) : <any>null;

      }
  }

  static fromJS(data: any): CheckUpDTO {
      data = typeof data === 'object' ? data : {};
      let result = new CheckUpDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["presentation"] = this.presentation ? this.presentation.toJSON() : <any>undefined;
      data["checkUpStatus"] = this.checkUpStatus ? this.checkUpStatus.toJSON() : <any>undefined;
      data["medicalProfile"] = this.medicalProfile ? this.medicalProfile.toJSON() : <any>undefined;
      data["freeFormPrez"] = this.freeFormPrez;
      data["diagnosisPrez"] = this.diagnosisPrez ? this.diagnosisPrez.toJSON() : <any>undefined;
      data["freeFormClinic"] = this.freeFormClinic;
      data["diagnosisClinic"] = this.diagnosisClinic ? this.diagnosisClinic.toJSON() : <any>undefined;
      data["diet"] = this.diet ? this.diet.toJSON() : <any>undefined;
      data["precutations"] = this.precutations;
      data["protocol"] = this.protocol ? this.protocol.toJSON() : <any>undefined;
      data["treatment"] = this.treatment ? this.treatment.toJSON() : <any>undefined;
      data["treatmentRegime"] = this.treatmentRegime ? this.treatmentRegime.toJSON() : <any>undefined;
      data["checkUpDate"] = this.checkUpDate ? this.checkUpDate.toISOString() : <any>undefined;
      data["nextDate"] = this.nextDate ? this.nextDate.toISOString() : <any>undefined;
      data["medicalAnalysisBatches"] = this.medicalAnalysisBatches;
      data["investigationTypes"] = this.investigationTypes;
      data["dateUpdate"] = this.dateUpdate ? this.dateUpdate.toISOString() : <any>null;

      return data;
  }
}

export interface ICheckUpDTO {
  id?: number;
  presentation?: PresentationDTO;
  checkUpStatus?: CheckUpStatusDTO;
  medicalProfile?: MedicalProfileDTO;
  freeFormPrez?: string | undefined;
  diagnosisPrez?: DiagnosisDTO;
  freeFormClinic?: string | undefined;
  diagnosisClinic?: DiagnosisDTO;
  diet?: DietDTO;
  precutations?: string | undefined;
  protocol?: ProtocolDTO;
  treatment?: TreatmentDTO;
  treatmentRegime?: TreatmentRegimeDTO;
  checkUpDate?: Date | undefined;
  nextDate?: Date | undefined;
  medicalAnalysisBatches?: string | undefined;
  investigationTypes?: string | undefined;  
  dateUpdate?: Date | null;
}



export class DiagnosisClassDTO implements IDiagnosisClassDTO {
  id?: number;
  name?: string | null;
  codeDRG?: string | null;

  constructor(data?: IDiagnosisClassDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
          this.codeDRG = _data["codeDRG"] !== undefined ? _data["codeDRG"] : <any>null;
      }
  }

  static fromJS(data: any): DiagnosisClassDTO {
      data = typeof data === 'object' ? data : {};
      let result = new DiagnosisClassDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      data["codeDRG"] = this.codeDRG !== undefined ? this.codeDRG : <any>null;
      return data;
  }
}

export interface IDiagnosisClassDTO {
  id?: number;
  name?: string | null;
  codeDRG?: string | null;
}
export class ProtocolDTO implements IProtocolDTO {
  id?: number;
  name?: string | undefined;

  constructor(data?: IProtocolDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
      }
  }

  static fromJS(data: any): ProtocolDTO {
      data = typeof data === 'object' ? data : {};
      let result = new ProtocolDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      return data;
  }
}

export interface IProtocolDTO {
  id?: number;
  name?: string | undefined;
}

export class DiagnosisDTO implements IDiagnosisDTO {
  id?: number;
  name?: string | undefined;
  code?: string | undefined;
  codeDRG?: string | undefined;
  diagnosisClass?: DiagnosisClassDTO;
  protocol?: ProtocolDTO;

  constructor(data?: IDiagnosisDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.code = _data["code"];
          this.codeDRG = _data["codeDRG"];
          this.diagnosisClass = _data["diagnosisClass"] ? DiagnosisClassDTO.fromJS(_data["diagnosisClass"]) : <any>undefined;
          this.protocol = _data["protocol"] ? ProtocolDTO.fromJS(_data["protocol"]) : <any>undefined;
      }
  }

  static fromJS(data: any): DiagnosisDTO {
      data = typeof data === 'object' ? data : {};
      let result = new DiagnosisDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["code"] = this.code;
      data["codeDRG"] = this.codeDRG;
      data["diagnosisClass"] = this.diagnosisClass ? this.diagnosisClass.toJSON() : <any>undefined;
      data["protocol"] = this.protocol ? this.protocol.toJSON() : <any>undefined;
      return data;
  }
}

export interface IDiagnosisDTO {
  id?: number;
  name?: string | undefined;
  code?: string | undefined;
  codeDRG?: string | undefined;
  diagnosisClass?: DiagnosisClassDTO;
  protocol?: ProtocolDTO;
}


export interface IDiagnosisTypeDTO {
  id?: number;
  name?: string | null;
}
export interface IMedicalProfileDTO {
  id?: number;
  name?: string | null;
}


export class CheckUpDTOFormItemResult implements ICheckUpDTOFormItemResult {
  entityDTO?: CheckUpDTO;
  formAccess?: FormAccessDTO;

  constructor(data?: ICheckUpDTOFormItemResult) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.entityDTO = _data["entityDTO"] ? CheckUpDTO.fromJS(_data["entityDTO"]) : <any>null;
          this.formAccess = _data["formAccess"] ? FormAccessDTO.fromJS(_data["formAccess"]) : <any>null;
      }
  }

  static fromJS(data: any): CheckUpDTOFormItemResult {
      data = typeof data === 'object' ? data : {};
      let result = new CheckUpDTOFormItemResult();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["entityDTO"] = this.entityDTO ? this.entityDTO.toJSON() : <any>null;
      data["formAccess"] = this.formAccess ? this.formAccess.toJSON() : <any>null;
      return data;
  }
}

export interface ICheckUpDTOFormItemResult {
  entityDTO?: CheckUpDTO;
  formAccess?: FormAccessDTO;
}

export class CheckUpStatusDTO implements ICheckUpStatusDTO {
  id?: number;
  name?: string | null;

  constructor(data?: ICheckUpStatusDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): CheckUpStatusDTO {
      data = typeof data === 'object' ? data : {};
      let result = new CheckUpStatusDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface ICheckUpStatusDTO {
  id?: number;
  name?: string | null;
}



export class ConsultationSelectValueDTO implements IConsultationSelectValueDTO {
  id?: number;
  name?: string | null;
  tag?: string | null;
  consultationTag?: string | null;

  constructor(data?: IConsultationSelectValueDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
          this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
          this.consultationTag = _data["consultationTag"] !== undefined ? _data["consultationTag"] : <any>null;
      }
  }

  static fromJS(data: any): ConsultationSelectValueDTO {
      data = typeof data === 'object' ? data : {};
      let result = new ConsultationSelectValueDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      data["tag"] = this.tag !== undefined ? this.tag : <any>null;
      data["consultationTag"] = this.consultationTag !== undefined ? this.consultationTag : <any>null;
      return data;
  }
}

export interface IConsultationSelectValueDTO {
  id?: number;
  name?: string | null;
  tag?: string | null;
  consultationTag?: string | null;
}


export class BloodGroupDTO implements IBloodGroupDTO {
  id?: number;
  name?: string | null;

  constructor(data?: IBloodGroupDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): BloodGroupDTO {
      data = typeof data === 'object' ? data : {};
      let result = new BloodGroupDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface IBloodGroupDTO {
  id?: number;
  name?: string | null;
}


export class RHDTO implements IRHDTO {
  id?: number;
  name?: string | null;

  constructor(data?: IRHDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): RHDTO {
      data = typeof data === 'object' ? data : {};
      let result = new RHDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface IRHDTO {
  id?: number;
  name?: string | null;
}



export class SkinColorDTO implements ISkinColorDTO {
  id?: number;
  name?: string | null;

  constructor(data?: ISkinColorDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): SkinColorDTO {
      data = typeof data === 'object' ? data : {};
      let result = new SkinColorDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface ISkinColorDTO {
  id?: number;
  name?: string | null;
}

export class SkinDTO implements ISkinDTO {
  id?: number;
  name?: string | null;

  constructor(data?: ISkinDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): SkinDTO {
      data = typeof data === 'object' ? data : {};
      let result = new SkinDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface ISkinDTO {
  id?: number;
  name?: string | null;
}

export class SkinHumidityDTO implements ISkinHumidityDTO {
  id?: number;
  name?: string | null;

  constructor(data?: ISkinHumidityDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): SkinHumidityDTO {
      data = typeof data === 'object' ? data : {};
      let result = new SkinHumidityDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface ISkinHumidityDTO {
  id?: number;
  name?: string | null;
}

export class SkinTurgorDTO implements ISkinTurgorDTO {
  id?: number;
  name?: string | null;

  constructor(data?: ISkinTurgorDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): SkinTurgorDTO {
      data = typeof data === 'object' ? data : {};
      let result = new SkinTurgorDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface ISkinTurgorDTO {
  id?: number;
  name?: string | null;
}

export class SmokeQuantityDTO implements ISmokeQuantityDTO {
  id?: number;
  name?: string | null;

  constructor(data?: ISmokeQuantityDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): SmokeQuantityDTO {
      data = typeof data === 'object' ? data : {};
      let result = new SmokeQuantityDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface ISmokeQuantityDTO {
  id?: number;
  name?: string | null;
}

export class SurveyDTO implements ISurveyDTO {
  id?: number;
  presentationId?: number | null;
  presentation?: PresentationDTO;
  temperature?: string | null;
  bloodPressureLeft?: string | null;
  bloodPressureRight?: string | null;
  heartRate?: string | null;
  concentrationCO2?: string | null;
  breathFrequncy?: string | null;
  electrocardiography?: string | null;
  anthropometry?: string | null;
  glucometry?: string | null;
  recommendationExam?: string | null;
  surveyDate?: Date | null;

  constructor(data?: ISurveyDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.presentationId = _data["presentationId"] !== undefined ? _data["presentationId"] : <any>null;
          this.presentation = _data["presentation"] ? PresentationDTO.fromJS(_data["presentation"]) : <any>null;
          this.temperature = _data["temperature"] !== undefined ? _data["temperature"] : <any>null;
          this.bloodPressureLeft = _data["bloodPressureLeft"] !== undefined ? _data["bloodPressureLeft"] : <any>null;
          this.bloodPressureRight = _data["bloodPressureRight"] !== undefined ? _data["bloodPressureRight"] : <any>null;
          this.heartRate = _data["heartRate"] !== undefined ? _data["heartRate"] : <any>null;
          this.concentrationCO2 = _data["concentrationCO2"] !== undefined ? _data["concentrationCO2"] : <any>null;
          this.breathFrequncy = _data["breathFrequncy"] !== undefined ? _data["breathFrequncy"] : <any>null;
          this.electrocardiography = _data["electrocardiography"] !== undefined ? _data["electrocardiography"] : <any>null;
          this.anthropometry = _data["anthropometry"] !== undefined ? _data["anthropometry"] : <any>null;
          this.glucometry = _data["glucometry"] !== undefined ? _data["glucometry"] : <any>null;
          this.recommendationExam = _data["recommendationExam"] !== undefined ? _data["recommendationExam"] : <any>null;
          this.surveyDate = _data["surveyDate"] ? new Date(_data["surveyDate"].toString()) : <any>null;
      }
  }

  static fromJS(data: any): SurveyDTO {
      data = typeof data === 'object' ? data : {};
      let result = new SurveyDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["presentationId"] = this.presentationId !== undefined ? this.presentationId : <any>null;
      data["presentation"] = this.presentation ? this.presentation.toJSON() : <any>null;
      data["temperature"] = this.temperature !== undefined ? this.temperature : <any>null;
      data["bloodPressureLeft"] = this.bloodPressureLeft !== undefined ? this.bloodPressureLeft : <any>null;
      data["bloodPressureRight"] = this.bloodPressureRight !== undefined ? this.bloodPressureRight : <any>null;
      data["heartRate"] = this.heartRate !== undefined ? this.heartRate : <any>null;
      data["concentrationCO2"] = this.concentrationCO2 !== undefined ? this.concentrationCO2 : <any>null;
      data["breathFrequncy"] = this.breathFrequncy !== undefined ? this.breathFrequncy : <any>null;
      data["electrocardiography"] = this.electrocardiography !== undefined ? this.electrocardiography : <any>null;
      data["anthropometry"] = this.anthropometry !== undefined ? this.anthropometry : <any>null;
      data["glucometry"] = this.glucometry !== undefined ? this.glucometry : <any>null;
      data["recommendationExam"] = this.recommendationExam !== undefined ? this.recommendationExam : <any>null;
      data["surveyDate"] = this.surveyDate ? this.surveyDate.toISOString() : <any>null;
      return data;
  }
}

export interface ISurveyDTO {
  id?: number;
  presentationId?: number | null;
  presentation?: PresentationDTO;
  temperature?: string | null;
  bloodPressureLeft?: string | null;
  bloodPressureRight?: string | null;
  heartRate?: string | null;
  concentrationCO2?: string | null;
  breathFrequncy?: string | null;
  electrocardiography?: string | null;
  anthropometry?: string | null;
  glucometry?: string | null;
  recommendationExam?: string | null;
  surveyDate?: Date | null;
}

export class SurveyDTOFormItemResult implements ISurveyDTOFormItemResult {
  entityDTO?: SurveyDTO;
  formAccess?: FormAccessDTO;

  constructor(data?: ISurveyDTOFormItemResult) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.entityDTO = _data["entityDTO"] ? SurveyDTO.fromJS(_data["entityDTO"]) : <any>null;
          this.formAccess = _data["formAccess"] ? FormAccessDTO.fromJS(_data["formAccess"]) : <any>null;
      }
  }

  static fromJS(data: any): SurveyDTOFormItemResult {
      data = typeof data === 'object' ? data : {};
      let result = new SurveyDTOFormItemResult();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["entityDTO"] = this.entityDTO ? this.entityDTO.toJSON() : <any>null;
      data["formAccess"] = this.formAccess ? this.formAccess.toJSON() : <any>null;
      return data;
  }
}

export interface ISurveyDTOFormItemResult {
  entityDTO?: SurveyDTO;
  formAccess?: FormAccessDTO;
}

export class SurveyRiskFactorDTO implements ISurveyRiskFactorDTO {
  id?: number;
  survey?: SurveyDTO;
  surveyRiskFactorDate?: Date | null;
  alimentations?: string | null;
  drinkFrequency?: DrinkFrequencyDTO;
  drugNames?: string | null;
  physicalActivity?: PhysicalActivityDTO;
  smokeNames?: string | null;
  smokeQuantity?: SmokeQuantityDTO;
  smoking?: boolean | null;
  drinking?: boolean | null;
  drugsConsume?: boolean | null;
  drinkName?: string | null;
  drinkQuantity?: string | null;
  anamnesisAllergic?: AnamnesisAllergicDTO;
  anamnesisAllergicAggravations?: string | null;
  anamnesisDescription?: string | null;

  constructor(data?: ISurveyRiskFactorDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.survey = _data["survey"] ? SurveyDTO.fromJS(_data["survey"]) : <any>null;
          this.surveyRiskFactorDate = _data["surveyRiskFactorDate"] ? new Date(_data["surveyRiskFactorDate"].toString()) : <any>null;
          this.alimentations = _data["alimentations"] !== undefined ? _data["alimentations"] : <any>null;
          this.drinkFrequency = _data["drinkFrequency"] ? DrinkFrequencyDTO.fromJS(_data["drinkFrequency"]) : <any>null;
          this.drugNames = _data["drugNames"] !== undefined ? _data["drugNames"] : <any>null;
          this.physicalActivity = _data["physicalActivity"] ? PhysicalActivityDTO.fromJS(_data["physicalActivity"]) : <any>null;
          this.smokeNames = _data["smokeNames"] !== undefined ? _data["smokeNames"] : <any>null;
          this.smokeQuantity = _data["smokeQuantity"] ? SmokeQuantityDTO.fromJS(_data["smokeQuantity"]) : <any>null;
          this.smoking = _data["smoking"] !== undefined ? _data["smoking"] : <any>null;
          this.drinking = _data["drinking"] !== undefined ? _data["drinking"] : <any>null;
          this.drugsConsume = _data["drugsConsume"] !== undefined ? _data["drugsConsume"] : <any>null;
          this.drinkName = _data["drinkName"] !== undefined ? _data["drinkName"] : <any>null;
          this.drinkQuantity = _data["drinkQuantity"] !== undefined ? _data["drinkQuantity"] : <any>null;
          this.anamnesisAllergic = _data["anamnesisAllergic"] ? AnamnesisAllergicDTO.fromJS(_data["anamnesisAllergic"]) : <any>null;
          this.anamnesisAllergicAggravations = _data["anamnesisAllergicAggravations"] !== undefined ? _data["anamnesisAllergicAggravations"] : <any>null;
          this.anamnesisDescription = _data["anamnesisDescription"] !== undefined ? _data["anamnesisDescription"] : <any>null;
      }
  }

  static fromJS(data: any): SurveyRiskFactorDTO {
      data = typeof data === 'object' ? data : {};
      let result = new SurveyRiskFactorDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["survey"] = this.survey ? this.survey.toJSON() : <any>null;
      data["surveyRiskFactorDate"] = this.surveyRiskFactorDate ? this.surveyRiskFactorDate.toISOString() : <any>null;
      data["alimentations"] = this.alimentations !== undefined ? this.alimentations : <any>null;
      data["drinkFrequency"] = this.drinkFrequency ? this.drinkFrequency.toJSON() : <any>null;
      data["drugNames"] = this.drugNames !== undefined ? this.drugNames : <any>null;
      data["physicalActivity"] = this.physicalActivity ? this.physicalActivity.toJSON() : <any>null;
      data["smokeNames"] = this.smokeNames !== undefined ? this.smokeNames : <any>null;
      data["smokeQuantity"] = this.smokeQuantity ? this.smokeQuantity.toJSON() : <any>null;
      data["smoking"] = this.smoking !== undefined ? this.smoking : <any>null;
      data["drinking"] = this.drinking !== undefined ? this.drinking : <any>null;
      data["drugsConsume"] = this.drugsConsume !== undefined ? this.drugsConsume : <any>null;
      data["drinkName"] = this.drinkName !== undefined ? this.drinkName : <any>null;
      data["drinkQuantity"] = this.drinkQuantity !== undefined ? this.drinkQuantity : <any>null;
      data["anamnesisAllergic"] = this.anamnesisAllergic ? this.anamnesisAllergic.toJSON() : <any>null;
      data["anamnesisAllergicAggravations"] = this.anamnesisAllergicAggravations !== undefined ? this.anamnesisAllergicAggravations : <any>null;
      data["anamnesisDescription"] = this.anamnesisDescription !== undefined ? this.anamnesisDescription : <any>null;
      return data;
  }
}

export interface ISurveyRiskFactorDTO {
  id?: number;
  survey?: SurveyDTO;
  surveyRiskFactorDate?: Date | null;
  alimentations?: string | null;
  drinkFrequency?: DrinkFrequencyDTO;
  drugNames?: string | null;
  physicalActivity?: PhysicalActivityDTO;
  smokeNames?: string | null;
  smokeQuantity?: SmokeQuantityDTO;
  smoking?: boolean | null;
  drinking?: boolean | null;
  drugsConsume?: boolean | null;
  drinkName?: string | null;
  drinkQuantity?: string | null;
  anamnesisAllergic?: AnamnesisAllergicDTO;
  anamnesisAllergicAggravations?: string | null;
  anamnesisDescription?: string | null;
}

export class SurveyRiskFactorDTOFormItemResult implements ISurveyRiskFactorDTOFormItemResult {
  entityDTO?: SurveyRiskFactorDTO;
  formAccess?: FormAccessDTO;

  constructor(data?: ISurveyRiskFactorDTOFormItemResult) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.entityDTO = _data["entityDTO"] ? SurveyRiskFactorDTO.fromJS(_data["entityDTO"]) : <any>null;
          this.formAccess = _data["formAccess"] ? FormAccessDTO.fromJS(_data["formAccess"]) : <any>null;
      }
  }

  static fromJS(data: any): SurveyRiskFactorDTOFormItemResult {
      data = typeof data === 'object' ? data : {};
      let result = new SurveyRiskFactorDTOFormItemResult();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["entityDTO"] = this.entityDTO ? this.entityDTO.toJSON() : <any>null;
      data["formAccess"] = this.formAccess ? this.formAccess.toJSON() : <any>null;
      return data;
  }
}

export interface ISurveyRiskFactorDTOFormItemResult {
  entityDTO?: SurveyRiskFactorDTO;
  formAccess?: FormAccessDTO;
}


export class PhysicalActivityDTO implements IPhysicalActivityDTO {
  id?: number;
  name?: string | null;

  constructor(data?: IPhysicalActivityDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): PhysicalActivityDTO {
      data = typeof data === 'object' ? data : {};
      let result = new PhysicalActivityDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface IPhysicalActivityDTO {
  id?: number;
  name?: string | null;
}
export class AnamnesisAllergicDTO implements IAnamnesisAllergicDTO {
  id?: number;
  name?: string | null;

  constructor(data?: IAnamnesisAllergicDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): AnamnesisAllergicDTO {
      data = typeof data === 'object' ? data : {};
      let result = new AnamnesisAllergicDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface IAnamnesisAllergicDTO {
  id?: number;
  name?: string | null;
}

export class DrinkFrequencyDTO implements IDrinkFrequencyDTO {
  id?: number;
  name?: string | null;

  constructor(data?: IDrinkFrequencyDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): DrinkFrequencyDTO {
      data = typeof data === 'object' ? data : {};
      let result = new DrinkFrequencyDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface IDrinkFrequencyDTO {
  id?: number;
  name?: string | null;
}


export class SurveyYearlyDTO implements ISurveyYearlyDTO {
  id?: number;
  survey?: SurveyDTO;
  surveyYearlyDate?: Date | null;
  hivTest?: HIVTestDTO;
  mrsReaction?: HIVTestDTO;
  limfoExam?: LimfoExamDTO;
  omsRisk?: OMSRiskDTO;
  omsType?: OMSTypeDTO;
  pathologicalChanges?: string | null;
  intraocularPressure?: string | null;
  skin?: SkinDTO;
  skinColor?: SkinColorDTO;
  skinHumidity?: SkinHumidityDTO;
  skinTurgor?: SkinTurgorDTO;
  skinExam?: string | null;
  tiroidExam?: string | null;
  mamarExam?: string | null;
  arterialPreasure?: string | null;
  weight?: number | null;
  height?: number | null;
  imc?: number | null;
  abdominalCircumference?: string | null;
  ocularTonometry?: string | null;
  visualAcuity?: string | null;
  glucose?: string | null;
  rmp?: string | null;
  ginecologyExam?: string | null;
  ginecologyExamDate?: Date | null;
  lungsRadiograph?: string | null;
  totalCholesterol?: string | null;
  bloodSugar?: string | null;
  rectalCough?: string | null;
  perimetry?: string | null;
  indicationUrogenital?: string | null;
  indicationPulmonaryRagiography?: string | null;
  indicationRectalCough?: string | null;
  counselingSmoking?: string | null;
  counselingAlcohol?: string | null;

  constructor(data?: ISurveyYearlyDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.survey = _data["survey"] ? SurveyDTO.fromJS(_data["survey"]) : <any>null;
          this.surveyYearlyDate = _data["surveyYearlyDate"] ? new Date(_data["surveyYearlyDate"].toString()) : <any>null;
          this.hivTest = _data["hivTest"] ? HIVTestDTO.fromJS(_data["hivTest"]) : <any>null;
          this.mrsReaction = _data["mrsReaction"] ? HIVTestDTO.fromJS(_data["mrsReaction"]) : <any>null;
          this.limfoExam = _data["limfoExam"] ? LimfoExamDTO.fromJS(_data["limfoExam"]) : <any>null;
          this.omsRisk = _data["omsRisk"] ? OMSRiskDTO.fromJS(_data["omsRisk"]) : <any>null;
          this.omsType = _data["omsType"] ? OMSTypeDTO.fromJS(_data["omsType"]) : <any>null;
          this.pathologicalChanges = _data["pathologicalChanges"] !== undefined ? _data["pathologicalChanges"] : <any>null;
          this.intraocularPressure = _data["intraocularPressure"] !== undefined ? _data["intraocularPressure"] : <any>null;
          this.skin = _data["skin"] ? SkinDTO.fromJS(_data["skin"]) : <any>null;
          this.skinColor = _data["skinColor"] ? SkinColorDTO.fromJS(_data["skinColor"]) : <any>null;
          this.skinHumidity = _data["skinHumidity"] ? SkinHumidityDTO.fromJS(_data["skinHumidity"]) : <any>null;
          this.skinTurgor = _data["skinTurgor"] ? SkinTurgorDTO.fromJS(_data["skinTurgor"]) : <any>null;
          this.skinExam = _data["skinExam"] !== undefined ? _data["skinExam"] : <any>null;
          this.tiroidExam = _data["tiroidExam"] !== undefined ? _data["tiroidExam"] : <any>null;
          this.mamarExam = _data["mamarExam"] !== undefined ? _data["mamarExam"] : <any>null;
          this.arterialPreasure = _data["arterialPreasure"] !== undefined ? _data["arterialPreasure"] : <any>null;
          this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
          this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
          this.imc = _data["imc"] !== undefined ? _data["imc"] : <any>null;
          this.abdominalCircumference = _data["abdominalCircumference"] !== undefined ? _data["abdominalCircumference"] : <any>null;
          this.ocularTonometry = _data["ocularTonometry"] !== undefined ? _data["ocularTonometry"] : <any>null;
          this.visualAcuity = _data["visualAcuity"] !== undefined ? _data["visualAcuity"] : <any>null;
          this.glucose = _data["glucose"] !== undefined ? _data["glucose"] : <any>null;
          this.rmp = _data["rmp"] !== undefined ? _data["rmp"] : <any>null;
          this.ginecologyExam = _data["ginecologyExam"] !== undefined ? _data["ginecologyExam"] : <any>null;
          this.ginecologyExamDate = _data["ginecologyExamDate"] ? new Date(_data["ginecologyExamDate"].toString()) : <any>null;
          this.lungsRadiograph = _data["lungsRadiograph"] !== undefined ? _data["lungsRadiograph"] : <any>null;
          this.totalCholesterol = _data["totalCholesterol"] !== undefined ? _data["totalCholesterol"] : <any>null;
          this.bloodSugar = _data["bloodSugar"] !== undefined ? _data["bloodSugar"] : <any>null;
          this.rectalCough = _data["rectalCough"] !== undefined ? _data["rectalCough"] : <any>null;
          this.perimetry = _data["perimetry"] !== undefined ? _data["perimetry"] : <any>null;
          this.indicationUrogenital = _data["indicationUrogenital"] !== undefined ? _data["indicationUrogenital"] : <any>null;
          this.indicationPulmonaryRagiography = _data["indicationPulmonaryRagiography"] !== undefined ? _data["indicationPulmonaryRagiography"] : <any>null;
          this.indicationRectalCough = _data["indicationRectalCough"] !== undefined ? _data["indicationRectalCough"] : <any>null;
          this.counselingSmoking = _data["counselingSmoking"] !== undefined ? _data["counselingSmoking"] : <any>null;
          this.counselingAlcohol = _data["counselingAlcohol"] !== undefined ? _data["counselingAlcohol"] : <any>null;
      }
  }

  static fromJS(data: any): SurveyYearlyDTO {
      data = typeof data === 'object' ? data : {};
      let result = new SurveyYearlyDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["survey"] = this.survey ? this.survey.toJSON() : <any>null;
      data["surveyYearlyDate"] = this.surveyYearlyDate ? this.surveyYearlyDate.toISOString() : <any>null;
      data["hivTest"] = this.hivTest ? this.hivTest.toJSON() : <any>null;
      data["mrsReaction"] = this.mrsReaction ? this.mrsReaction.toJSON() : <any>null;
      data["limfoExam"] = this.limfoExam ? this.limfoExam.toJSON() : <any>null;
      data["omsRisk"] = this.omsRisk ? this.omsRisk.toJSON() : <any>null;
      data["omsType"] = this.omsType ? this.omsType.toJSON() : <any>null;
      data["pathologicalChanges"] = this.pathologicalChanges !== undefined ? this.pathologicalChanges : <any>null;
      data["intraocularPressure"] = this.intraocularPressure !== undefined ? this.intraocularPressure : <any>null;
      data["skin"] = this.skin ? this.skin.toJSON() : <any>null;
      data["skinColor"] = this.skinColor ? this.skinColor.toJSON() : <any>null;
      data["skinHumidity"] = this.skinHumidity ? this.skinHumidity.toJSON() : <any>null;
      data["skinTurgor"] = this.skinTurgor ? this.skinTurgor.toJSON() : <any>null;
      data["skinExam"] = this.skinExam !== undefined ? this.skinExam : <any>null;
      data["tiroidExam"] = this.tiroidExam !== undefined ? this.tiroidExam : <any>null;
      data["mamarExam"] = this.mamarExam !== undefined ? this.mamarExam : <any>null;
      data["arterialPreasure"] = this.arterialPreasure !== undefined ? this.arterialPreasure : <any>null;
      data["weight"] = this.weight !== undefined ? this.weight : <any>null;
      data["height"] = this.height !== undefined ? this.height : <any>null;
      data["imc"] = this.imc !== undefined ? this.imc : <any>null;
      data["abdominalCircumference"] = this.abdominalCircumference !== undefined ? this.abdominalCircumference : <any>null;
      data["ocularTonometry"] = this.ocularTonometry !== undefined ? this.ocularTonometry : <any>null;
      data["visualAcuity"] = this.visualAcuity !== undefined ? this.visualAcuity : <any>null;
      data["glucose"] = this.glucose !== undefined ? this.glucose : <any>null;
      data["rmp"] = this.rmp !== undefined ? this.rmp : <any>null;
      data["ginecologyExam"] = this.ginecologyExam !== undefined ? this.ginecologyExam : <any>null;
      data["ginecologyExamDate"] = this.ginecologyExamDate ? this.ginecologyExamDate.toISOString() : <any>null;
      data["lungsRadiograph"] = this.lungsRadiograph !== undefined ? this.lungsRadiograph : <any>null;
      data["totalCholesterol"] = this.totalCholesterol !== undefined ? this.totalCholesterol : <any>null;
      data["bloodSugar"] = this.bloodSugar !== undefined ? this.bloodSugar : <any>null;
      data["rectalCough"] = this.rectalCough !== undefined ? this.rectalCough : <any>null;
      data["perimetry"] = this.perimetry !== undefined ? this.perimetry : <any>null;
      data["indicationUrogenital"] = this.indicationUrogenital !== undefined ? this.indicationUrogenital : <any>null;
      data["indicationPulmonaryRagiography"] = this.indicationPulmonaryRagiography !== undefined ? this.indicationPulmonaryRagiography : <any>null;
      data["indicationRectalCough"] = this.indicationRectalCough !== undefined ? this.indicationRectalCough : <any>null;
      data["counselingSmoking"] = this.counselingSmoking !== undefined ? this.counselingSmoking : <any>null;
      data["counselingAlcohol"] = this.counselingAlcohol !== undefined ? this.counselingAlcohol : <any>null;
      return data;
  }
}

export interface ISurveyYearlyDTO {
  id?: number;
  survey?: SurveyDTO;
  surveyYearlyDate?: Date | null;
  mrsReaction?: HIVTestDTO;
  hivTest?: HIVTestDTO;
  limfoExam?: LimfoExamDTO;
  omsRisk?: OMSRiskDTO;
  omsType?: OMSTypeDTO;
  pathologicalChanges?: string | null;
  intraocularPressure?: string | null;
  skin?: SkinDTO;
  skinColor?: SkinColorDTO;
  skinHumidity?: SkinHumidityDTO;
  skinTurgor?: SkinTurgorDTO;
  skinExam?: string | null;
  tiroidExam?: string | null;
  mamarExam?: string | null;
  arterialPreasure?: string | null;
  weight?: number | null;
  height?: number | null;
  imc?: number | null;
  abdominalCircumference?: string | null;
  ocularTonometry?: string | null;
  visualAcuity?: string | null;
  glucose?: string | null;
  rmp?: string | null;
  ginecologyExam?: string | null;
  ginecologyExamDate?: Date | null;
  lungsRadiograph?: string | null;
  totalCholesterol?: string | null;
  bloodSugar?: string | null;
  rectalCough?: string | null;
  perimetry?: string | null;
  indicationUrogenital?: string | null;
  indicationPulmonaryRagiography?: string | null;
  indicationRectalCough?: string | null;
  counselingSmoking?: string | null;
  counselingAlcohol?: string | null;
}

export class SurveyYearlyDTOFormItemResult implements ISurveyYearlyDTOFormItemResult {
  entityDTO?: SurveyYearlyDTO;
  formAccess?: FormAccessDTO;

  constructor(data?: ISurveyYearlyDTOFormItemResult) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.entityDTO = _data["entityDTO"] ? SurveyYearlyDTO.fromJS(_data["entityDTO"]) : <any>null;
          this.formAccess = _data["formAccess"] ? FormAccessDTO.fromJS(_data["formAccess"]) : <any>null;
      }
  }

  static fromJS(data: any): SurveyYearlyDTOFormItemResult {
      data = typeof data === 'object' ? data : {};
      let result = new SurveyYearlyDTOFormItemResult();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["entityDTO"] = this.entityDTO ? this.entityDTO.toJSON() : <any>null;
      data["formAccess"] = this.formAccess ? this.formAccess.toJSON() : <any>null;
      return data;
  }
}

export interface ISurveyYearlyDTOFormItemResult {
  entityDTO?: SurveyYearlyDTO;
  formAccess?: FormAccessDTO;
}


export class HIVTestDTO implements IHIVTestDTO {
  id?: number;
  name?: string | null;

  constructor(data?: IHIVTestDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): HIVTestDTO {
      data = typeof data === 'object' ? data : {};
      let result = new HIVTestDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface IHIVTestDTO {
  id?: number;
  name?: string | null;
}


export class LimfoExamDTO implements ILimfoExamDTO {
  id?: number;
  name?: string | null;

  constructor(data?: ILimfoExamDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): LimfoExamDTO {
      data = typeof data === 'object' ? data : {};
      let result = new LimfoExamDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface ILimfoExamDTO {
  id?: number;
  name?: string | null;
}



export class OMSRiskDTO implements IOMSRiskDTO {
  id?: number;
  name?: string | null;

  constructor(data?: IOMSRiskDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): OMSRiskDTO {
      data = typeof data === 'object' ? data : {};
      let result = new OMSRiskDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface IOMSRiskDTO {
  id?: number;
  name?: string | null;
}

export class OMSTypeDTO implements IOMSTypeDTO {
  id?: number;
  name?: string | null;

  constructor(data?: IOMSTypeDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): OMSTypeDTO {
      data = typeof data === 'object' ? data : {};
      let result = new OMSTypeDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface IOMSTypeDTO {
  id?: number;
  name?: string | null;
}

export class InsuranceStatusDTO implements IInsuranceStatusDTO {
  id?: number;
  name?: string | undefined;

  constructor(data?: IInsuranceStatusDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
      }
  }

  static fromJS(data: any): InsuranceStatusDTO {
      data = typeof data === 'object' ? data : {};
      let result = new InsuranceStatusDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      return data;
  }
}

export interface IInsuranceStatusDTO {
  id?: number;
  name?: string | undefined;
}


export class PaymentStatusDTO implements IPaymentStatusDTO {
  id?: number;
  name?: string | null;

  constructor(data?: IPaymentStatusDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): PaymentStatusDTO {
      data = typeof data === 'object' ? data : {};
      let result = new PaymentStatusDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}

export interface IPaymentStatusDTO {
  id?: number;
  name?: string | null;
}

export class BaseNomDTO implements IBaseNomDTO {
  id?: number;
  name?: string | null;
  tag?: string | null;
  color?: string | null;

  constructor(data?: IBaseNomDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
          this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
          this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
      }
  }

  static fromJS(data: any): BaseNomDTO {
      data = typeof data === 'object' ? data : {};
      let result = new BaseNomDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      data["tag"] = this.tag !== undefined ? this.tag : <any>null;
      data["color"] = this.color !== undefined ? this.color : <any>null;
      return data;
  }
}

export interface IBaseNomDTO {
  id?: number;
  name?: string | null;
  tag?: string | null;
  color?: string | null;
}

export interface ISampleTypeDTO {
  id?: number;
  writeRevision?: boolean | null;
  name?: string | null;
  tag?: string | null;
  color?: string | null;
}


export class DynamicSectionStatsDTO implements IDynamicSectionStatsDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    count?: number;
    color?: string | null;

    constructor(data?: IDynamicSectionStatsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
        }
    }

    static fromJS(data: any): DynamicSectionStatsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicSectionStatsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        return data;
    }
}

export interface IDynamicSectionStatsDTO {
    id?: number;
    writeRevision?: boolean | null;
    name?: string | null;
    count?: number;
    color?: string | null;
}
